<style lang="less">

.wx-page{
    position:relative;
    overflow-y: auto;
    width:100%;
    height:100%;
    padding:15px 0;

    .page-wrap{
        position:relative;
        overflow:hidden;
        width:1080px;
        min-height:100%;
        margin:0 auto;
        padding:15px;
        background:#ffffff;
        clear:both;
    }

}

</style>
<template lang="html">
	<div class="wx-page">
		<div class="page-wrap">
			<slot></slot>
		</div>
	</div>
</template>

<script>

// import pageMaxin from '@components/mixins/page.js';

export default {
	// mixins: [pageMaxin],
    data:function(){
        return {

        }
    },
    components: {

    },
    mounted(){
		
	},
	computed:{
		// pageWrapStyle:function(){
		// 	return{
		// 		'min-height':(this.$store.state.indexConH-30)+'px'
		// 	}
		// }
	},
	methods: {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Page.vue